import {ModelContext} from '../../types/app.types';

export class PriceModel {
  public convertedAmount: number;
  public formattedConvertedAmount: string;

  constructor(params: PriceModel) {
    this.convertedAmount = params.convertedAmount;
    this.formattedConvertedAmount = params.formattedConvertedAmount;
  }

  public static fromGQL({convertedAmount, modelContext}: {convertedAmount?: number; modelContext: ModelContext}) {
    return new PriceModel({
      convertedAmount,
      formattedConvertedAmount: modelContext.formatAmount(convertedAmount),
    });
  }

  public static fromSDK(
    multiCurrencyPrice: {convertedAmount?: string; formattedConvertedAmount?: string},
    modelContext: ModelContext
  ) {
    return new PriceModel({
      convertedAmount: parseFloat(multiCurrencyPrice?.convertedAmount),
      formattedConvertedAmount: modelContext.formatAmount(multiCurrencyPrice?.convertedAmount),
    });
  }
}
